import type { Channel, CustomRole, Message, TeamMember } from '@nexo/types';
import { channelLabel } from '../channels/ChannelSidebar';
import { toEditable } from '../chat/mentions';
import { t } from '../../lib/i18n';
import { notify, playSound } from './alerts';
import { effectiveLevel, mentionsMe } from './channelNotify';

/**
 * Discord-like alert for a message from someone else that the user is not looking at: DMs and
 * mentions always (unless the conversation is set to «nothing»), other messages only in
 * conversations set to «all messages»; muted conversations stay silent.
 */
export function alertForMessage(
  message: Message,
  context: {
    meId: string;
    channel: Channel | undefined;
    members: TeamMember[];
    roles: CustomRole[];
    open: () => void;
  },
): void {
  const { meId, channel, members, roles } = context;
  const level = channel ? effectiveLevel(channel) : 'all';
  const mention = mentionsMe(message, channel, { id: meId, members, roles });
  if (level === 'none' || level === 'muted') return;
  if (level === 'mentions' && !mention) return;

  playSound(mention ? 'mention' : 'message');
  const direct = channel?.kind === 'dm';
  const where = channel ? (direct ? t('Mensaje directo') : channelLabel(channel)) : 'Nexo';
  const text = toEditable(message.body, members, roles).replace(/\s+/g, ' ').trim();
  void notify({
    title: direct
      ? message.author.displayName
      : t('{{name}} en {{where}}', { name: message.author.displayName, where }),
    body:
      (text || (message.attachments.length > 0 ? t('📎 Archivo adjunto') : '')).slice(0, 180) ||
      undefined,
    tag: message.channelId,
    onClick: context.open,
  });
}
